import './footer.css'

//MUI
import { Box, Container, Divider, Grid, Stack, Typography } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';

import logo from '../../assets/images/Logo_Farmacias_nefropolis_Blanco.png'

//Components
import Contact from '../Contact/Contact'

//Router dom
import { Link } from 'react-router-dom'

// const CodyIframe = () => {
//     return (
//         <iframe
//             src="https://embed.cody.bot/9efbfd9a-1dbd-4ef1-9371-a5955e9ab66e"
//             style={{ border: '0px' }}
//             name="codyai"
//             height="150px"
//             width="150px"
//             allowFullScreen
//             title="Cody AI"
//         ></iframe>
//     );
// };

const Footer = ({ FormRef }) => {
    return (
        <footer style={{ borderRadius: '30px 30px 0 0' }} ref={FormRef}>
            <Container className='footer_container' maxWidth='xl' sx={{ py: 5 }}>
                <Box className='footer_logo_container' sx={{ mb: 6 }}>
                    <img src={logo} alt={logo} className='footer_logo' width='200px' style={{ pointerEvents: 'none' }} />
                </Box>

                <Grid container spacing={4}>
                    <Grid item xxl={3} xl={3} lg={3} md={6} sm={6} xs={12} sx={{ mx: 'auto', textAlign: { xxl: 'left', xl: 'left', lg: 'left', md: 'center', sm: 'center', xs: 'center' } }}>
                        <Typography variant='h6' sx={{ fontWeight: 'bold' }}>Documentos</Typography>
                        <Stack spacing={1} mt={3}>
                            <Link to="/preguntas-frecuentes" style={{ color: '#fff' }}>FAQS</Link>
                            <Link to="/politica-de-privacidad" style={{ color: '#fff' }}>Aviso de privacidad</Link>
                            <Link to="/terminos-y-condiciones" style={{ color: '#fff' }}>Términos y condiciones</Link>
                            <Link to="/politica-de-envios" style={{ color: '#fff' }}>Política de Envíos</Link>
                            <Link to="/politica-de-facturacion" style={{ color: '#fff' }}>Política de facturación</Link>
                        </Stack>
                    </Grid>
                    <Grid item xxl={3} xl={3} lg={3} md={6} sm={6} xs={12} sx={{ mx: 'auto', textAlign: { xxl: 'left', xl: 'left', lg: 'left', md: 'center', sm: 'center', xs: 'center' } }}>
                        <Typography variant='h6' sx={{ fontWeight: 'bold' }}>Contacto</Typography>
                        <Stack spacing={1} mt={3} sx={{ color: '#fff' }}>
                            <Box>
                                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                                    Chat 24/7
                                </Typography>
                                <Typography variant='body1'>
                                    Resuelve tus dudas <a href='https://share.cody.bot/9efbfd9a-1dbd-4ef1-9371-a5955e9ab66e'
                                    style={{ color: '#fff', textDecoration: 'underline' }}>aquí.</a>
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                                    Ventas en línea
                                </Typography>
                                <Box display='flex' gap='8px'
                                    sx={{ justifyContent: { xxl: 'flex-start', xl: 'flex-start', lg: 'flex-start', md: 'center', sm: 'center', xs: 'center' } }}
                                >
                                    <WhatsAppIcon sx={{ my: 'auto' }} />
                                    <a href='https://api.whatsapp.com/send?phone=523311468502&text=Hola,+quisiera+m%C3%A1s+informaci%C3%B3n+sobre+(escriba+el+tema+sobre+el+que+quiera+saber+m%C3%A1s)'
                                        style={{ textDecoration: 'none', color: '#fff' }}>+ 33 1146 8502</a>
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                                    Atención telefónica
                                </Typography>
                                <Box display='flex' gap='8px'
                                    sx={{ justifyContent: { xxl: 'flex-start', xl: 'flex-start', lg: 'flex-start', md: 'center', sm: 'center', xs: 'center' } }}
                                >
                                    <PhoneIcon sx={{ my: 'auto' }} />
                                    <Box sx={{ my: 'auto' }}>
                                        <a href='https://outlook.office365.com/book/PamelaRomeroCedeo@nefropolis.com/?ismsaljsauthenabled=true'
                                        style={{ textDecoration: 'underline', color: '#fff' }}>Agenda una llamada</a>
                                    </Box>
                                </Box>
                            </Box>
                        </Stack>
                    </Grid>
                    <Grid item xxl={6} xl={6} lg={6} md={8} sm={12} xs={12} sx={{ mx: 'auto' }}>
                        <Typography variant='h6' sx={{ color: '#fff', fontWeight: 'bold' }}>
                            Déjanos un mensaje
                        </Typography>
                        <Typography variant='body1' sx={{ color: '#fff' }}>
                            Déjanos tus datos y te contactaremos por correo electrónico para brindarte más información
                        </Typography>
                        <Box sx={{ mt: 3 }}>
                            <Contact />
                        </Box>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 5, backgroundColor: '#fff' }} />
                <Box className='copyright'>
                    Nefrópolis © {new Date().getFullYear()}
                </Box>
            </Container>

            {/* <Box height={6}></Box>

            <Box sx={{ bgcolor: '#fff', py: 5 }}>
                <Container maxWidth='xl'>
                    <Contact />
                </Container>
            </Box>

            <Box className='links_footer' mt={3}>
                <Link to="/politica-de-privacidad" style={{ color: '#fff' }}>Aviso de privacidad <span className='links_footer_line'>|</span> </Link>
                <Link to="/terminos-y-condiciones" style={{ color: '#fff' }}>Términos y condiciones <span className='links_footer_line'>|</span> </Link>
                <Link to="/politica-de-envios" style={{ color: '#fff' }}>Política de Envíos <span className='links_footer_line'>|</span> </Link>
                <Link to="/politica-de-facturacion" style={{ color: '#fff' }}>Política de facturación <span className='links_footer_line'>|</span> </Link>
                <Link to={"/sucursales"} style={{ color: '#fff' }}>Sucursales <span className='links_footer_line'>|</span> </Link>
                <Link to="/preguntas-frecuentes" style={{ color: '#fff' }}>FAQS <span className='links_footer_line'>|</span> </Link>
            </Box>

            <Box className='copyright' sx={{ py: 3 }}>
                Nefrópolis © {new Date().getFullYear()}
            </Box> */}
        </footer>
    )
}

export default Footer